//时间
export const dateTime = (value,index) =>{
    if(value && value !== '0' && value != '86430'){
        var date = new Date(value*1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = date.getDate() < 10 ? '0'+date.getDate() : date.getDate() 
        if(index){
            var h = ' '+(date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
            var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':'
            var s = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds()
            return Y+M+D+h+m+s
        }else{
            return Y+M+D
        }
    }else{
        return ''
    }
}

//保留小数点后数值
export const numFilter = (value,index) => {
    // 截取当前数据到小数点后三位
    let i = parseInt(index)
    let tempVal = parseFloat(value).toFixed(i)
    let realVal = tempVal.substring(0,  tempVal.length - 1)
    return realVal
}


// WEBPACK FOOTER //
// ./src/apis/filter.js